import AutocompleteFormik from "@/common/components/form/AutocompleteFormik";
import InputFormik from "@/common/components/form/InputFormik";
import ButtonWithLoader from "@/common/components/ui/loading/ButtonLoading";
import { maskCurrency } from "@/common/helpers/mask.helpers";
import { IPurchaseOrder } from "@/types/purchaseOrder.types";
import { useFormikContext } from "formik";
import { useEffect, useState } from "react";
import { ImCheckboxChecked, ImCheckboxUnchecked } from "react-icons/im";
import { useGetAllProducts } from "../../hooks";
import Permission from "@/common/components/auth/Permission";

type Props = {
  index: number;
  isCounted: boolean;
  labelIsCounted: string;
  labelIsNotCounted: string;
  qtdComponentsPieces: number;
  removeComponentProduct: () => void;
}

type Option = {
  value: string,
  label: string,
};

function ComponentProduct(props: Props) {

  const [isCounted, setIsCounted] = useState<boolean>(false);
  const [isNotCounted, setIsNotCounted] = useState<boolean>(false);

  const { setFieldValue } = useFormikContext<IPurchaseOrder>();
  const { data: items } = useGetAllProducts()

  const options: Option[] = [
    ...(items ? items.map((item) => ({
      value: item.productId,
      label: item.description,
    })) : []),
  ];

  useEffect(() => {
    if (isCounted && isNotCounted) {
      setFieldValue(props.labelIsNotCounted, undefined);
      setFieldValue(props.labelIsCounted, undefined);
      setIsNotCounted(false);
      setIsCounted(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isCounted, isNotCounted]);

  return (

    <div id="componentProduct" key={props.index + 2}>
      <div className="col-span-3 bg-gray/40 p-4 dark:text-black rounded-md">

        <Permission permission="moviment:stock">
          <div className=" ml-2 mb-5 relative color flex items-center">
            <label htmlFor={props.labelIsCounted} className="block text-sm font-medium text-gray-600">
              {isCounted ? <div className="flex gap-2 items-center justify-start text-greenPrimary">
                <ImCheckboxChecked />
                <span>É movimento de estoque</span>
              </div>

                : <div className="flex gap-2 items-center justify-start">
                  <ImCheckboxUnchecked />
                  <span>É movimento de estoque</span>
                </div>}
              <input
                id={props.labelIsCounted}
                name={props.labelIsCounted}
                type="checkbox"
                checked={isCounted}
                onChange={() => {
                  const newValue = !isCounted;
                  setIsCounted(newValue);
                  setFieldValue(props.labelIsCounted, newValue);
                }}
                className="border p-2 rounded w-full absolute opacity-0"
              />
            </label>


            <label htmlFor={props.labelIsNotCounted} className="ml-2 block text-sm font-medium text-gray-600">

              {isNotCounted ? <div className="flex gap-2 items-center justify-start text-redPrimary">
                <ImCheckboxChecked />
                <span>Não é movimento de estoque</span>
              </div>

                : <div className="flex gap-2 items-center justify-start">
                  <ImCheckboxUnchecked />
                  <span>Não é movimento de estoque</span>
                </div>}

              <input
                id={props.labelIsNotCounted}
                name={props.labelIsCounted}
                type="checkbox"
                checked={isNotCounted}
                onChange={() => {
                  const newValue = !isNotCounted;
                  setIsNotCounted(newValue);
                  setFieldValue(props.labelIsCounted, false);
                }}
                className="border p-2 rounded w-full absolute opacity-0"
              />
            </label>
          </div>
        </Permission>


        {isCounted ? <AutocompleteFormik
          label="Descrição da Compra:"
          name={`item${props.index}`}
          required={true}
          options={options.length > 0 ? options : []}
          className='w-small mt-1'
        />
          : <InputFormik label="Descrição da Compra:" name={`item${props.index}`}></InputFormik>
        }
        <InputFormik
          label='Quantidade:'
          name={`qtd${props.index}`}
          className='w-small mt-1'
          required={true}
          type="number"
        />
        <InputFormik
          label='Valor:'
          name={`value${props.index}`}
          mask={maskCurrency}
          className='w-small mt-1'
          required={true}
        />
        <div className="flex justify-end">
          {props.qtdComponentsPieces > 1 && <ButtonWithLoader onClick={props.removeComponentProduct}> Remover </ButtonWithLoader>}
        </div>
      </div>
      <div className="mt-3"></div>
    </div>
  );
}

export default ComponentProduct;
